import { UserRole } from '@/types';

export type EffectiveRole = 'super_admin' | 'admin' | 'manager' | 'engineer';

export const normalizeRole = (role?: UserRole | string | null): EffectiveRole => {
  if (!role) return 'engineer';
  
  // Only support exact 4 base roles
  if (role === 'super_admin') return 'super_admin';
  if (role === 'admin') return 'admin';
  if (role === 'manager') return 'manager';
  if (role === 'engineer') return 'engineer';
  
  // Default fallback
  return 'engineer';
};

export const isSuperAdmin = (role?: UserRole | string | null): boolean => {
  return normalizeRole(role) === 'super_admin';
};

export const isAdminOrAbove = (role?: UserRole | string | null): boolean => {
  const effective = normalizeRole(role);
  return effective === 'super_admin' || effective === 'admin';
};

export const isAdminOrManager = (role?: UserRole | string | null): boolean => {
  const effective = normalizeRole(role);
  return effective === 'super_admin' || effective === 'admin' || effective === 'manager';
};
